import { FCWithChildren } from '@types';
import React from 'react';
import { Button, Modal, ModalBody, Loading } from '@components';

type ModalWifiEnabledProps = {
  isOpen: boolean;
  onClose: () => void;
  loading?: boolean;
};

const ModalAccountPending: FCWithChildren<ModalWifiEnabledProps> = ({
  isOpen,
  loading = false,
  onClose,
}) => {
  return (
    <Modal
      customWebClass="xl:w-1/3 l:w-2/3 m:w-90"
      maxWidthClass="max-w-90"
      closeModal={onClose}
      isOpen={isOpen}
    >
      <ModalBody>
        <h1 className="text-3xl">Almost there - your account is being created!</h1>
        {loading ? (
          <div className="flex justify-center m-10">
            <Loading size="small" />
          </div>
        ) : (
          'We are setting things up. We’ll email you as soon as your account is ready with instructions to get started.'
        )}
        {!loading && (
          <div className="flex justify-center mt-6">
            <Button layout="secondary" className="w-32" onClick={onClose}>
              Close
            </Button>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalAccountPending;
